<template>
<div class="chapter">
<div class="inner_page">
<p class="prect"><a id="pVI"></a><a id="pVII"></a>Maps</p>
<div class="nl">
<p class="nl"><a href="#/ch1.htm#map_01"><span class="numblock">1</span>Europe, August 1914</a></p>
<p class="nl"><a href="#/ch1.htm#map_02"><span class="numblock">2</span>Naval plans against Germany, 1914–15</a></p>
<p class="nl"><a href="#/ch3.htm#map_03"><span class="numblock">3</span>The Dardanelles defences</a></p>
<p class="nl"><a href="#/ch6.htm#map_04"><span class="numblock">4</span>The Gallipoli Peninsula</a></p>
<p class="nl"><a href="#/ch6.htm#map_05"><span class="numblock">5</span>The topography at Anzac</a></p>
<p class="nl"><a href="#/ch6.htm#map_06"><span class="numblock">6</span>The military plan</a></p>
<p class="nl"><a href="#/ch7.htm#map_07"><span class="numblock">7</span>Landings and objectives, 25 April</a></p>
<p class="nl"><a href="#/ch7.htm#map_08"><span class="numblock">8</span>The Helles Landing</a></p>
<p class="nl"><a href="#/ch8.htm#map_09"><span class="numblock">9</span>Anzac: the situation at the end of April</a></p>
<p class="nl"><a href="#/ch8.htm#map_10"><span class="numblock">10</span>Anzac: the situation on 19 May</a></p>
<p class="nl"><a href="#/ch9.htm#map_11"><span class="numblock">11</span>The First Battle of Krithia, 28 April</a></p>
<p class="nl"><a href="#/ch9.htm#map_12"><span class="numblock">12</span>The Turkish night attack, 1–2 May</a></p>
<p class="nl"><a href="#/ch9.htm#map_13"><span class="numblock">13</span>The Second Battle of Krithia, 6–8 May: the objectives</a></p>
<p class="nl"><a href="#/ch9.htm#map_14"><span class="numblock">14</span>The Second Battle of Krithia, 6–8 May</a></p>
<p class="nl"><a href="#/ch10.htm#map_15"><span class="numblock">15</span>The Third Battle of Krithia, 4 June</a></p>
<p class="nl"><a href="#/ch10.htm#map_16"><span class="numblock">16</span>Helles: ground gained, 21 June–13 July</a></p>
<p class="nl"><a href="#/ch12.htm#map_17"><span class="numblock">17</span>The Anzac plan: August</a></p>
<p class="nl"><a href="#/ch12.htm#map_18"><span class="numblock">18</span>Anzac: evening, 7 August</a></p>
<p class="nl"><a href="#/ch12.htm#map_19"><span class="numblock">19</span>Anzac: evening, 8 August</a></p>
<p class="nl"><a href="#/ch12.htm#map_20"><span class="numblock">20</span>Anzac: evening, 9 August</a></p>
<p class="nl"><a href="#/ch12.htm#map_21"><span class="numblock">21</span>Anzac: dawn, 10 August</a></p>
<p class="nl"><a href="#/ch13.htm#map_22"><span class="numblock">22</span>Suvla Bay: the objectives</a></p>
<p class="nl"><a href="#/ch13.htm#map_23"><span class="numblock">23</span>Suvla Bay: Turkish dispositions, 6 August</a></p>
<p class="nl"><a href="#/ch13.htm#map_24"><span class="numblock">24</span>Suvla Bay: morning, 7 August</a></p>
<p class="nl"><a href="#/ch13.htm#map_25"><span class="numblock">25</span>Suvla Bay: evening, 7 August</a></p>
<p class="nl"><a href="#/ch13.htm#map_26"><span class="numblock">26</span>Suvla Bay: evening, 8 August</a></p>
<p class="nl"><a href="#/ch15.htm#map_27"><span class="numblock">27</span>The evacuation of Anzac, 20 December</a></p>
<p class="nl"><a href="#/ch15.htm#map_28"><span class="numblock">28</span>The evacuation of Helles, 8–9 January 1916</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// list_of_maps.vue?15994b24